import settingsConfig from 'DashboardBuilder/settingsConfig'
import SettingsSchemaForm from 'Shared/components/Settings/SettingsSchemaForm'
import './SettingsForm.scoped.scss'
import { useAct } from 'DashboardBuilder/store'

export default function SettingsForm() {
  const { settings } = useSel((s) => s.dashboard)
  const act = useAct()

  const onChange = (key, value) => {
    act.dashboard.updateSetting(key, value)
  }

  return (
    <div className="dashboard-settings">
      <SettingsSchemaForm
        onChange={onChange}
        settings={settings}
        config={settingsConfig}
      />
    </div>
  )
}
